var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"id":"currency-icon"}},[(_vm._currency === 'UAH')?[_vm._v("₴")]:(_vm._currency === 'USD' || _vm._currency === 'USDT')?[_vm._v("$")]:[_vm._v("₽")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }